import { render, staticRenderFns } from "./TaxInvoiceList.vue?vue&type=template&id=2c3a14ae&scoped=true"
import script from "./TaxInvoiceList.vue?vue&type=script&lang=js"
export * from "./TaxInvoiceList.vue?vue&type=script&lang=js"
import style0 from "./TaxInvoiceList.vue?vue&type=style&index=0&id=2c3a14ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c3a14ae",
  null
  
)

export default component.exports